import { render, staticRenderFns } from "./shears-scissors-and-comb-skills.vue?vue&type=template&id=5487a04d&scoped=true&"
import script from "./shears-scissors-and-comb-skills.vue?vue&type=script&lang=js&"
export * from "./shears-scissors-and-comb-skills.vue?vue&type=script&lang=js&"
import style0 from "./shears-scissors-and-comb-skills.vue?vue&type=style&index=0&id=5487a04d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5487a04d",
  null
  
)

export default component.exports